
import API_BASE from "../config/api";

export const fetchCustomerLedgerBalance = async () => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Customer/LedgerBalance`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch balance");
  }

  return await response.json();
};